@if (nextEvent && (timeLeft | async); as t) {
  <div class="flex justify-center">
    <div class="inline-block shadow-2xl rounded-lg overflow-hidden text-center bg-white/40 dark:bg-black/40 cursor-pointer" (click)="openTwitch()" [title]="streamHint">
      <div class="px-10 py-1">
        <p class="text-xl text-orange-500 mb-0">{{ eventHeadline }}</p>
        <div class="wrapper">
          <div class="description">
            <p>Tagen</p>
            <p>Stunden</p>
            <p>Minuten</p>
            <p>Sekunden</p>
          </div>
          <div class="times text-semibold text-orange-500">
            <p #days>{{t.daysToDday}}</p>
            <p #hours>{{t.hoursToDday}}</p>
            <p #minutes>{{t.minutesToDday}}</p>
            <p #seconds>{{t.secondsToDday}}</p>
          </div>
        </div>
        <p class="event-date mb-0 text-orange-500">{{ eventDateLabel }}</p>
        @if (eventSubtitle) {
          <p class="event-subtitle mb-0 text-orange-500/80">{{ eventSubtitle }}</p>
        }
      </div>
    </div>
  </div>
} @else {
  <div></div>
}

